import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import ptBR from "@angular/common/locales/pt";

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { RouterModule } from "@angular/router";

import { AppRoutingModule } from "./app-routing.module";

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { PdfViewerModule } from "ng2-pdf-viewer";

import {
    NgxBootstrapIconsModule,
    alarm,
    alarmFill,
    alignBottom,
    chevronDown,
    chevronUp,
    arrowRightShort,
} from "ngx-bootstrap-icons";

import { AlertModule } from "ngx-bootstrap/alert";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { NgxSpinnerModule } from "ngx-spinner";

import { AppComponent } from "./app.component";
import { MainComponent } from "./main/main.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { BuscaComponent } from "./main/busca/busca.component";
import { CardBuscaComponent } from "./main/busca/card-busca/card-busca.component";
import { DiplomaComponent } from "./diploma/diploma.component";
import { DadosComponent } from "./diploma/dados/dados.component";
import { SexoEStatusPipe } from "./pipes/sexo-estatus.pipe";
import { OrderByPipe } from "./pipes/order-by.pipe";

// Select some icons (use an object, not an array)
const icons = {
    alarm,
    alarmFill,
    alignBottom,
    chevronDown,
    chevronUp,
    arrowRightShort,
};

// Config Locale
registerLocaleData(ptBR);

@NgModule({
    declarations: [
        AppComponent,
        BuscaComponent,
        CardBuscaComponent,
        DiplomaComponent,
        MainComponent,
        NavbarComponent,
        DadosComponent,
        SexoEStatusPipe,
        OrderByPipe,
    ],
    exports: [SexoEStatusPipe, OrderByPipe],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AccordionModule.forRoot(),
        CollapseModule.forRoot(),
        NgxBootstrapIconsModule.pick(icons),
        PaginationModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        RouterModule,
        AlertModule.forRoot(),
        NgxSpinnerModule,
        PdfViewerModule,
        NgxMaskDirective,
        NgxMaskPipe,
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: "pt-BR",
        },
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi()),
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
